import styled, { css } from 'styled-components'

export const PaymentMethodAlert = styled.div<{ $isCash: boolean }>(
  ({ theme, $isCash }) => css`
    display: flex;
    align-items: start;
    gap: ${theme.space['4']};
    color: ${$isCash ? theme.colors.orange500 : theme.colors.black500};
    background-color: ${$isCash ? theme.colors.orange100 : theme.colors.gray100};
    padding: ${theme.space['8']};
    border-radius: ${theme.border.radius['8']};

    & > svg {
      flex-shrink: 0;
    }
  `,
)
